export default "__VITE_PUBLIC_ASSET__6218136d__"